import React from 'react';

import { type ApexOptions } from 'apexcharts';
import ApexCharts from 'react-apexcharts';

interface BarChartProps
  extends Omit<React.ComponentProps<typeof ApexCharts>, 'options' | 'series'> {
  labels: Array<string>;
  data: Array<number>;
  percent: Array<number>;
}

export const BarChart: React.FC<BarChartProps> = ({
  labels,
  data,
  percent,
  ...other
}) => {
  const options: ApexOptions = {
    chart: {
      type: 'bar',
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    xaxis: {
      categories: labels,
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number, opts?: ExplicitAny): string => {
        const percentValue = percent[opts.dataPointIndex];
        return `${val} (${percentValue?.toFixed(1)}%)`;
      },
    },
    colors: ['#B56BFF'],
  };

  const series = [{ name: 'Survey Responses', data }];

  return (
    <ApexCharts
      options={options}
      series={series}
      type="bar"
      width={780}
      height={data.length < 5 ? 180 : 350}
      {...other}
    />
  );
};
